import React, {useEffect, useRef, useState} from "react";
import {
    Alert,
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide,
    styled,
} from "@mui/material";
import ValidationRuleSection from "./ValidationRuleSection";
import {useDispatch, useSelector} from "react-redux";
import {fetchValidationRules} from "../features/validationRuleSlice";
import Box from "@mui/material/Box";
import {handleHttpResponse} from "../utils/http-helpers";
import DialogContentText from "@mui/material/DialogContentText";
import ShowSnackbar from "../utils/ShowSnackbar";
import {ApiUrl} from "../utils/portal-urls";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import ValidationRuleAutoComplete from "./ValidationRuleAutoComplete";
import {CustomBackdrop} from "../utils/customStyles";

/** Summary table style */
// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//     [`&.${tableCellClasses.head}`]: {
//         backgroundColor: theme.palette.primary.main,
//         color: theme.palette.common.white,
//     },
//     [`&.${tableCellClasses.body}`]: {
//         fontSize: 14,
//     },
// }));
//
// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//         backgroundColor: theme.palette.action.hover,
//     },
//     // hide last border
//     '&:last-child td, &:last-child th': {
//         border: 0,
//     },
// }));

const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}))
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const StyledDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        width: '400px',
        height: '300px'
    }
})
/**
 * The PUBLISHABILITY codes the rule value may key on. The display label beside each code is the
 * administrator's to word -- DirectTrust renamed 2 from "Patients" to "Consumers only" on
 * 2026-08-12 -- so only the code is checked here, never the label text.
 */
const PUBLISHABILITY_CODES = ["1", "2", "3"];

export default function ValidationRulesHome() {

    const dispatch = useDispatch();
    const {data, loading, msg, initialRuleValue} = useSelector(state => state.validationRules);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogInfo, setDialogInfo] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState({open: false, msg: '', msgLv: ''})
    const [postRequestLoading, setPostRequestLoading] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [onRefresh, setRefresh] = useState(new Date().getTime());
    const [selectedValue, setSelectedValue] = useState(null);

    const [localStore, setLocalStore] = useState({});

    const formRef = useRef();

    useEffect(() => {
        dispatch(fetchValidationRules());
    }, [onRefresh])

    // useEffect(() => {
    //     let obj = {}
    //     data && data.map( rule => {
    //         if (rule.detailsAsMap.AllowValue) {
    //             obj[rule.name] = {...obj[rule.name], 'value':  rule.value};
    //         }
    //
    //         if (rule.detailsAsMap.AllowEccrValue) {
    //             obj[rule.name] = {...obj[rule.name], 'eccrValue': rule.eccrValue}
    //         }
    //
    //         if (rule.detailsAsMap.AllowFuzzyMatch) {
    //             obj[rule.name] = {...obj[rule.name], 'fuzzyRate': rule.fuzzyMatchRate};
    //         }
    //         obj[rule.name] = {...obj[rule.name], 'tolerated': rule.tolerated}
    //         obj[rule.name] = {...obj[rule.name], 'severity': rule.severity}
    //     })
    //     setLocalStore(obj);
    // }, [data])
    //
    // const handleRuleValueChange = ({name, value}) => {
    //     localStore[name].value = value;
    // }
    //
    // const handleEccrValueChange = ({name, value}) => {
    //      localStore[name].eccrValue = value;
    // }
    //
    // const handleFuzzyRateChange = ({name, value}) => {
    //     localStore[name].fuzzyRate = value;
    // }

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const refresh = () => {
        // formRef.current.reset();
        setRefresh(new Date().getTime());
        // window.location.reload();
        setIsChanged(false);
    }

    const handleSubmit = async () => {
        // let url = '/api/rule'
        let url = ApiUrl.ValidationRules.query.getPath();
        const invalidFuzzyRate = [];
        // Rule #9 is always in the payload; default to valid so its absence can never block a save.
        let isValidPublishabilityValue = true;

        /** check fuzzy match rate */
        data && data.forEach(rule => {
            // Same fallback as the rule editor: a rule whose fuzzyMatchRate is actually in use must be
            // range-checked on save even when its details JSON carries no AllowFuzzyMatch flag, or an
            // out-of-range rate saves silently on exactly the rules the editor now lets you change.
            const usesFuzzyMatch = Boolean(rule.detailsAsMap?.AllowFuzzyMatch)
                || (Number(rule.fuzzyMatchRate) > 0 && Number(rule.fuzzyMatchRate) < 100);
            if (usesFuzzyMatch) {
                if (rule.fuzzyMatchRate === 0 || rule.fuzzyMatchRate > 100) {
                    invalidFuzzyRate.push({'name': rule.name, 'fuzzyRate': rule.fuzzyMatchRate});
                }
            }
            if (rule.ruleId === 9) {
                const pub = rule.value;
                isValidPublishabilityValue = checkPublishability(pub);
            }
        })

        if (!isValidPublishabilityValue) {
            setSnackbarOpen({
                open: true,
                msg: 'The value for rule #9 is incorrect, please make sure the values are in right format',
                msgLv: 'warning'
            })
            return;
        }

        if (invalidFuzzyRate.length) {
            setDialogInfo(invalidFuzzyRate);
            setDialogOpen(true);
            setPostRequestLoading(false);
            return;
        }

        const requestOption = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }
        console.log(`POST request to ${url}`)

        try {
            setPostRequestLoading(true);
            const res = await fetch(url, requestOption);
            const data = await handleHttpResponse(res);
            setSnackbarOpen({open: true, msg: 'Successfully save the changes', msgLv: 'success'});
            setIsChanged(false);

            // show all rules after submit successfully
            // setSelectedValue(null);
        } catch (err) {
            console.error("Failed to save the changes" + err);
            setSnackbarOpen({open: true, msg: "Failed to save the changes", msgLv: 'error'});
        } finally {
            setPostRequestLoading(false);
        }
    }

    /** Every comma-separated pair must be "code:label", with a code the rule may key on. */
    const checkPublishability = (value) => {
        const pairs = (value || '').split(",").filter(pair => pair.trim());
        if (!pairs.length) {
            return false;
        }

        return pairs.every(pair => {
            const [key, ...rest] = pair.split(":");
            const label = rest.join(":").trim();
            return PUBLISHABILITY_CODES.includes(key.trim()) && label.length > 0;
        })
    }


    return (
        <StyledContainer>
            {msg && <Alert severity='info' icon={false}>{msg}</Alert>}
            {/* Dialog for invalid fuzzy match rate when submit */}
            <StyledDialog
                open={dialogOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleDialogClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Invalid Fuzzy Match Rate"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{color: 'primary.dark'}}>
                        {dialogInfo && dialogInfo.map((r, i) => {
                            return <li key={i}>{`${r.name}:`} <strong>{r.fuzzyRate}</strong></li>
                        })}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{display: 'flex', justifyContent: 'center'}}>
                    <Button onClick={handleDialogClose} variant='contained'>Cancel</Button>
                </DialogActions>
            </StyledDialog>

            <h3 className='title'>
                Validation Rules
                <div style={{float: 'right'}}>
                    <Button variant={!isChanged ? 'outlined' : 'contained'} startIcon={<SaveAltIcon/>}
                            onClick={handleSubmit} disabled={!isChanged}>Save Changes</Button>
                    <Button variant='outlined' startIcon={<RefreshIcon/>} onClick={refresh}
                            disabled={!isChanged}>Reset</Button>
                </div>
            </h3>
            {data && <ValidationRuleAutoComplete rules={data} selectedValue={selectedValue}
                                                 setSelectedValue={(c) => setSelectedValue(c)}/>}

            <Grid container spacing={1}>
                {data && Object.keys(initialRuleValue).length > 0 && data.map((rule) => {
                        if (selectedValue) {
                            if (selectedValue.ruleId === rule.ruleId) {
                                return (
                                    <ValidationRuleSection
                                        rule={rule}
                                        key={rule.ruleId}
                                        setIsChanged={(c) => setIsChanged(c)}
                                        onRefresh={onRefresh}
                                        initialRuleValue={initialRuleValue[rule.name]}
                                    />)
                            }
                        } else {
                            return (
                                <ValidationRuleSection
                                    rule={rule}
                                    key={rule.ruleId}
                                    setIsChanged={(c) => setIsChanged(c)}
                                    onRefresh={onRefresh}
                                    initialRuleValue={initialRuleValue[rule.name]}
                                />)
                        }
                    }
                )}
            </Grid>
            {(loading || postRequestLoading) &&
                <Alert severity='info' icon={<CircularProgress/>} sx={{display: 'flex', alignItems: 'center'}}>
                    <span>Loading validation rule ...</span>
                </Alert>}
            {!loading && !postRequestLoading && <Box textAlign='center'>
                <hr/>
                <div style={{float: 'right'}}>
                    <Button variant={!isChanged ? 'outlined' : 'contained'} startIcon={<SaveAltIcon/>}
                            onClick={handleSubmit} disabled={!isChanged}>Save Changes</Button>
                    <Button variant='outlined' startIcon={<RefreshIcon/>} onClick={refresh}
                            disabled={!isChanged} sx={{ml: 2}}>Reset</Button>
                </div>
                {/*<Button variant='contained' onClick={handleSubmit} startIcon={<SaveAltIcon/>} disabled={!isChanged}>Save*/}
                {/*    Changes</Button>*/}
            </Box>}

            <ShowSnackbar open={snackbarOpen.open} close={(c) => setSnackbarOpen(c)} msg={snackbarOpen}/>
            <CustomBackdrop open={loading || postRequestLoading}/>

        </StyledContainer>
    )
}
